import templateWorkflowDelete from './workflowDelete.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor($mdDialog, $mdMedia, eventService, workflowsService, uiService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onWorkflowDelete(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                selectedWorkflows: _params.selectedWorkflows,
                organizationName: _params.organizationName
              },
              template: templateWorkflowDelete,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (deletedWorkflows) {
              var idDeletedWorkflows = [];
              var len = deletedWorkflows.length;
              while (len--) {
                ctrl.onFinished({ workflow: deletedWorkflows[len] });
                idDeletedWorkflows.push(deletedWorkflows[len].id);
              }

              workflowsService
                .deleteWorkflows({ idWorkflows: idDeletedWorkflows })
                .then(function (data) {
                  if (data.status) {
                    eventService.credentialsChanged();
                    uiService.toast({
                      text: {
                        p1: idDeletedWorkflows.length,
                        p2: 'Workflow(s)',
                        p3: 'have been deleted'
                      }
                    });
                  }
                });
            });

          function dialogController($mdDialog, selectedWorkflows, organizationName) {
            this.selectedWorkflows = selectedWorkflows;
            this.organizationName = '';
            this.isOrganizationNameEqual = function () {
              return this.organizationName.toLowerCase() === organizationName.toLowerCase();
            };
            this.confirm = function () {
              $mdDialog.hide(this.selectedWorkflows);
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
